import { useTranslation } from 'next-i18next';
import React from 'react';
import { BsIcon } from '@hotelplan/core.basis.bs-icon';
import { useFdrGetLinkWithJotform } from 'components/domain/fdr-jotform';
import { NavigationIds } from 'components/domain/geo/navigation/GeoNavigation.types';
import { FdrPageComponentsFragment } from 'schemas/fragment/page-components/fdr-page-components.generated';
import {
  CustomBenefitButtonContainer,
  CustomBenefitButtonLink,
  CustomBenefitContainer,
  CustomBenefitItem,
  CustomBenefitItemContainer,
  CustomBenefitItemHeader,
  CustomBenefitItemIcon,
  CustomBenefitItemText,
  CustomBenefitSectionContent,
  CustomBenefitText,
  CustomBenefitTextWrapper,
} from './fdr-custom-benefits-page-component.styles';

const CUSTOM_BENEFITS_TOTAL = 4;
const CUSTOM_BENEFITS_ICONS = [
  'benefit-inspiration' as const,
  'benefit-ask' as const,
  'benefit-advice' as const,
  'benefit-travel' as const,
];

interface IFdrCustomBenefitsPageComponentProps {
  component: Extract<
    FdrPageComponentsFragment['components'][number],
    { __typename: 'FdrBenefitsComponent' }
  >;
}

const FdrCustomBenefitsPageComponent: React.FC<IFdrCustomBenefitsPageComponentProps> =
  ({ component }) => {
    const [t] = useTranslation('common');
    const { buttonLink } = component;

    const linkWithJotform = useFdrGetLinkWithJotform(buttonLink);
    const target = buttonLink.openMethod || '_self';

    return (
      <CustomBenefitSectionContent id={NavigationIds.BENEFITS}>
        <CustomBenefitContainer>
          <CustomBenefitTextWrapper>
            <CustomBenefitText>
              <h2>{t('customBenefits.title')}</h2>
            </CustomBenefitText>
          </CustomBenefitTextWrapper>
          <CustomBenefitItemContainer>
            {Array.from(
              { length: CUSTOM_BENEFITS_TOTAL },
              (_, index) => index
            ).map(i => {
              return (
                <CustomBenefitItem key={i}>
                  <CustomBenefitItemIcon>
                    <BsIcon
                      name={CUSTOM_BENEFITS_ICONS[i]}
                      className={CUSTOM_BENEFITS_ICONS[i]}
                      size="xxlg"
                    />
                  </CustomBenefitItemIcon>
                  <CustomBenefitItemHeader>
                    {t(`customBenefits.item.${i}.title`)}
                  </CustomBenefitItemHeader>
                  <CustomBenefitItemText
                    dangerouslySetInnerHTML={{
                      __html: t(`customBenefits.item.${i}.text`),
                    }}
                  />
                </CustomBenefitItem>
              );
            })}
          </CustomBenefitItemContainer>
          <CustomBenefitButtonContainer>
            <CustomBenefitButtonLink
              className={'request-button'}
              target={target}
              href={linkWithJotform.url}
            >
              {t('customBenefits.button.text')}
            </CustomBenefitButtonLink>
          </CustomBenefitButtonContainer>
        </CustomBenefitContainer>
      </CustomBenefitSectionContent>
    );
  };

export default FdrCustomBenefitsPageComponent;
